<template>
  <div :class="['log-details', extraClasses]">
    <div class="sub-header log-details__header">{{header}}</div>
    <div v-if="logDetails && logDetails.length" class="log-details__table" role="grid">
      <div
          class="log-details__row log-details__row-header"
          role="row">
        <div v-for="header in columnHeaders"
             :key="header"
             class="log-details__cell log-details__cell-header" role="columnheader">
          {{header}}
        </div>
      </div>
      <performance-log-detail-row
          v-for="log in logDetails"
          :ref="`logRow${log.retailer_campaign_id}`"
          :key="log.retailer_campaign_id"
          :detailKeys="detailKeys"
          :isSelected="log.retailer_campaign_id == selectedLogToView"
          :log="log">
      </performance-log-detail-row>
    </div>
  </div>
</template>

<script>
  import PerformanceLogDetailRow from './PerformanceLogDetailRow'

  export default {
    props: {
      extraClasses: String,
      header: {
        default: 'messages sent',
        type: String
      },
      logDetails: Array,
      selectedLogToView: [Number, String]
    },

    name: 'PerformanceLogDetails',

    components: {
      PerformanceLogDetailRow
    },

    data() {
      return {
        columnHeaders: ['retailer', 'date sent', 'messages sent', 'message'],
        delayedClearSelectedLogToView: null,
        delayedClearTime: 5000, // 5 seconds
        detailKeys: ['retailer', 'sent_time', 'sms_sent', 'final_sms_content'],
      }
    },

    methods: {
      clearSelectedLogToView() {
        clearTimeout(this.delayedClearSelectedLogToView)
        this.delayedClearSelectedLogToView = setTimeout(() => {
          this.$emit('setSelectedLogToView', null)
        }, this.delayedClearTime)
      },

      highlightRow() {
        const $log = this.$refs[`logRow${this.selectedLogToView}`]
        $log && $log[0].$el.scrollIntoView()
        this.clearSelectedLogToView()
      }
    },

    watch: {
      selectedLogToView: function() {
        this.selectedLogToView && this.highlightRow()
      },
    },
  }
</script>

<style lang="sass">
  @import '../../assets/sass/colors'
  .log-details
    padding: 1em 0

    &__header
      padding-bottom: 1em

    &__table
      text-align: left

    &__row
      display: grid
      grid-gap: 10px
      grid-template-columns: 19% 19% 19% 40%
      margin-bottom: 1rem
      padding: 0.5rem 1rem

    &__row-header
      font-family: 'AileronLight'
      font-size: 1.05rem
      font-weight: 900

    &__header,
    &__row-detail
      font-size: 0.9rem

    &__row-detail
      background-color: transparent
      border-radius: 8px
      transition: background-color 1s linear

    &__cell-detail,
    &__cell
      white-space: pre-line

    &__highlight
      background-color: $primary-transparent

    &__scheduled,
    &__pending
      color: $negative-color
      display: block

</style>
